import { Controller } from "@hotwired/stimulus"
import { Tooltip } from "bootstrap"

export default class extends Controller {
  static values = {
    trigger: { type: String, default: "hover focus" }
  }

  connect() {
    this.tooltip = new Tooltip(this.element, { trigger: this.triggerValue })
  }

  disconnect() {
    if (this.tooltip) {
      this.tooltip.dispose()
    }
  }
}
